import { whatsappLink } from "@/lib/api";
import { useQuote } from "@/context/QuoteContext";
import { useLang } from "@/i18n/LanguageContext";
import { MessageCircle, Phone, Sparkles, MessageSquareText } from "lucide-react";
import { PHONE } from "@/lib/api";

export default function MobileCTABar() {
  const { openQuote } = useQuote();
  const { t } = useLang();
  return (
    <div className="md:hidden fixed bottom-0 inset-x-0 z-50 glass border-t border-border px-3 py-2.5 flex items-center gap-2" data-testid="mobile-cta-bar">
      <button
        onClick={() => openQuote({ type: "quote" })}
        className="flex-1 flex items-center justify-center gap-1.5 rounded-full bg-primary text-primary-foreground py-3 text-sm font-semibold"
        data-testid="mobilebar-quote-btn"
      >
        <Sparkles className="w-4 h-4" /> {t("common.freeQuote")}
      </button>
      <a href={`tel:${PHONE.replace(/[^+\d]/g, "")}`} className="w-12 h-12 rounded-full bg-secondary text-white flex items-center justify-center" data-testid="mobilebar-call-btn">
        <Phone className="w-5 h-5" />
      </a>
      <a href={`sms:${PHONE.replace(/[^+\d]/g, "")}`} className="w-12 h-12 rounded-full bg-secondary/80 text-white flex items-center justify-center" data-testid="mobilebar-text-btn">
        <MessageSquareText className="w-5 h-5" />
      </a>
      <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" style={{ backgroundColor: "#25D366" }} className="w-12 h-12 rounded-full text-white flex items-center justify-center" data-testid="mobilebar-whatsapp-btn">
        <MessageCircle className="w-5 h-5" />
      </a>
    </div>
  );
}
